import {
  FilterType,
  FilterValue,
  InputType,
  SelectOption,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useTranslation } from "@coworker/locales";
import { ALERTS_ID } from "./useAlertsFilter";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";

export const EDS_DATES_ID = "edsDates";

export function useEdsDatesFilter(
  filterValues: FilterValue[],
  options: SelectOption[]
) {
  const { t } = useTranslation();
  const defaultValue = { filterId: EDS_DATES_ID, value: "" };

  const enabled =
    filterValues.find((filter) => filter.filterId === ALERTS_ID)?.value ===
    "eds";

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: EDS_DATES_ID,
      title: t("edsDatesString"),
      options,
      enabled,
      defaultValue,
    },
    t("allEdsDatesString")
  );
}
